import KatalLogger, { Level } from '@amzn/katal-logger';
import { LoggerEndpoints } from '../constants/constants';
import { ERROR_MESSAGE_TO_FILTER } from '../constants/logging';
import { getCurrentStage } from '../utilities';
import sentryFetch from "@amzn/sentry-fetch";

class Logger {
  constructor() {
    this.logger = this.createLogger();
    this.stage = getCurrentStage();
    this.endpoint = this.stage === 'PROD' ? LoggerEndpoints.PROD : LoggerEndpoints.ALPHA;
  }

  authenticatedSendToBackend = (serializedLogData) => {
    void sentryFetch(this.endpoint, {
      credentials: "include",
      method: "POST",
      body: serializedLogData,
    }).catch((e) => console.warn(e));
  };

  createLogger = () => {
    const identity = localStorage['IDENTITY'];
    return this.init({user: identity ? JSON.parse(identity).data : {username: 'Default User'}});
  };

  updateLogger = (identity) => {
    this.logger = this.init({user: identity});
  };

  init = (context) => {
    let logger = new KatalLogger({
                                   logThreshold: this.stage === 'PROD' ? Level.INFO : Level.DEBUG,
                                   url: this.endpoint,
                                   logToConsole: this.stage !== 'PROD' || localStorage['logToConsole'],
                                   context: context,
                                   sendToBackendOverride: this.authenticatedSendToBackend
                                 });
    logger.addErrorListener((error) => {
      if (!error || !error.message || this.filteredFalsePositiveErrors(error))
        return false;
      this.error('Unhandled Error - ' + error.message, error);
      return true;
    });
    return logger;
  }

  filteredFalsePositiveErrors = (error) => {
    return ERROR_MESSAGE_TO_FILTER.some(m => error.message.startsWith(m));
  }

  info(message, payload, error) {
    payload = this.trimPayload(payload);

    if (error) {
      this.logger.info(message, error, payload);
    } else {
      this.logger.info(message, payload);
    }
  };

  warn(message, payload, error) {
    payload = this.trimPayload(payload);
    if (error) {
      this.logger.warn(message, error, payload);
    } else {
      this.logger.warn(message, payload);
    }
  };

  error(message, error, payload) {
    payload = this.trimPayload(payload);
    if (error) {
      this.logger.error(message, error, payload);
    } else {
      this.logger.error(message, payload);
    }
  };

  debug(message, payload, error) {
    payload = this.trimPayload(payload);
    if (error) {
      this.logger.debug(message, error, payload);
    } else {
      this.logger.debug(message, payload);
    }
  };

  fatal(message, error, payload) {
    payload = payload || {};
    if (error) {
      this.logger.fatal(message, error, payload);
    } else {
      this.logger.fatal(message, payload);
    }
  };

  trimPayload(payload) {
    if (!payload) {
      return {};
    }
    if (typeof payload === 'object' && !Array.isArray(payload)) {
        return payload;
    }
    return {
      payload: payload
    };
  }
}

const logger = new Logger();

/**
 Usage:
 logger.debug(message, context);
 logger.info(message, context, error);
 */
export default logger;



// WEBPACK FOOTER //
// ./src/utils/logging.js